import { makeElementAnchor, getTargetElement } from "views/components/visualizations/OnClickPopover/anchors";
import dropdownPopover from "views/components/visualizations/OnClickPopover/dropdownPopover";
import PieOnClickPopoverDropdown from "views/components/visualizations/OnClickPopover/PieOnClickPopoverDropdown";
const buildAnchor = (e, gd) => makeElementAnchor(e, gd, getTargetElement);
const pieOnClickPopover = {
  buildAnchor,
  renderPopover: dropdownPopover(PieOnClickPopoverDropdown)
};
export default pieOnClickPopover;
